<template>
  <div class="certification-mini-program-log app-panel blank-h blank-v">
    <div class="app-search-controls">
      <div class="wrap">
        <p>姓名</p>
        <el-input placeholder="请输入姓名" v-model="search.name"></el-input>
      </div>
      <div class="wrap">
        <p>日期</p>
        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.period" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
      </div>
    </div>
    <div class="app-control app-table-control">
      <el-button type="primary" @click="searchParams">搜索</el-button>
      <el-button @click="resetParams">重置</el-button>
    </div>
    <el-table :data="datas" v-loading="loading">
      <el-table-column label="ID" prop="customer_id_card_info_id"></el-table-column>
      <el-table-column label="姓名" prop="id_card_name"></el-table-column>
      <el-table-column label="身份证号码" prop="id_card_num"></el-table-column>
      <el-table-column label="比对照片" width="160">
        <template slot-scope="{row}">
          <div class="imgs-wrap">
            <el-image :src="row.attachment_one.attachment_access_url" :preview-src-list="[row.attachment_one.attachment_access_url, row.attachment_two.attachment_access_url]"></el-image>
            <el-image :src="row.attachment_two.attachment_access_url" :preview-src-list="[row.attachment_one.attachment_access_url, row.attachment_two.attachment_access_url]"></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="相似度" prop="score"></el-table-column>
      <el-table-column label="项目名称" prop="project_attr_data.project_attr_name"></el-table-column>
      <el-table-column label="置业顾问" prop="user_attr_data.user_attr_name"></el-table-column>
      <el-table-column label="结果">
        <template slot-scope="{row}">
          <el-tag size="mini" type="danger" v-if="!row.face_compare_is_match">不通过</el-tag>
          <el-tag size="mini" type="success" v-else>通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="识别时间" prop="created_at"></el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
  </div>
</template>

<script>
  import CertificationService from '@/io/certification.js';

  export default {
    name: 'CertificationMiniProgramLog',
    data() {
      return {
        search: {
          name: '',
          period: [],
        },
        datas: [],
        loading: false,
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        }
      }
    },
    mounted () {
      this.initDatas();
    },
    methods: {
      initDatas() {
        this.loading = true;
        CertificationService.miniProgramListPage(
          this.search.name,
          this.search.period ? this.search.period[0] : '',
          this.search.period ? this.search.period[1] : '',
          this.page.currentPage
        ).then(res => {
          let source = res.data;
          if (!source.data.length && this.page.currentPage > 1) {
            this.page.currentPage--;
            this.initDatas();
          } else {
            this.datas = source.data;
            this.page.pageSize = source.per_page;
            this.page.total = source.total;
          }
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.name = '';
        this.search.period = [];
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>
  .certification-mini-program-log {
    &.blank-v {
      padding-bottom: 0;
    }
  }
</style>